import React, { useEffect, useState } from "react";
import { useDispatch } from "react-redux";
import {
    fetchOtherUserProfileRequest,
    followUserRequest,
    searchUserRequest,
    unfollowUserRequest,
} from "../../store/user/user.actions";
import { useSelector } from "react-redux";
import {
    getImage,
    getSearchedUsers,
    getUserProfile,
} from "../../store/user/user.selector";
import { IsNullOrEmpty } from "../../helpers/utility";
import { useNavigate } from "react-router-dom";
import _ from "underscore";
import NotFound from "../../assets/images/NotFound.svg";
import mailIcon from "../../assets/images/mail.svg";
import chatRoomIcon from "../../assets/images/chatroom.svg";
import moment from "moment";
import {
    Avatar,
    Box,
    Button,
    Grid,
    InputAdornment,
    Hidden,
    List,
    ListItem,
    ListItemAvatar,
    ListItemSecondaryAction,
    ListItemText,
    TextField,
} from "@material-ui/core";
import { SearchOutlined } from "@material-ui/icons";

export default function ProfileFollowing() {
    const dispatch = useDispatch();
    const [searchText, setSearchText] = useState("");
    const history = useNavigate();

    const { users, userProfile } = useSelector((state) => {
        return {
            userProfile: getUserProfile(state),
            users: getSearchedUsers(state),
        };
    });

    useEffect(() => {
        dispatch(searchUserRequest());
    }, []);

    const handleFollow = (item, status) => {
        if (status) {
            dispatch(followUserRequest({ following: item._id }));
        } else {
            dispatch(unfollowUserRequest({ following: item._id }));
        }
    };

    let searchedUsers = users;
    if (!IsNullOrEmpty(searchText)) {
        searchedUsers = searchedUsers.filter((x) => {
            return (
                x.fullName.toLowerCase().indexOf(searchText.toLowerCase()) > -1
            );
        });
    }

    searchedUsers = _.sortBy(searchedUsers, "isFollow").reverse();

    return (
        <Grid item sm={12} xs={12}>
            <div className="relative mx-auto w-full md:max-w-[294px] bg-white rounded-full">
                <input
                    onChange={(e) => setSearchText(e.target.value)}
                    placeholder="Search user"
                    type="search"
                    className="peer duration-300 ease-linear cursor-pointer relative z-[1] w-full h-11 md:w-[320px] rounded-full lg:valid:w-full border border-black-10 bg-transparent pl-11 md:pl-12 outline-none focus:cursor-text focus:border-orange-color focus:pl-11 focus:pr-4 placeholder:hidden"
                    id="search-input"
                />

                <svg
                    width="16"
                    height="16"
                    className="absolute inset-y-0 my-auto h-8 w-12 px-3 sm:px-3.5"
                    viewBox="0 0 16 16"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                >
                    <path
                        fillRule="evenodd"
                        clipRule="evenodd"
                        d="M6 2C3.79086 2 2 3.79086 2 6C2 8.20914 3.79086 10 6 10C8.20914 10 10 8.20914 10 6C10 3.79086 8.20914 2 6 2ZM0 6C0 2.68629 2.68629 0 6 0C9.31371 0 12 2.68629 12 6C12 7.29583 11.5892 8.49572 10.8907 9.47653L15.7071 14.2929C16.0976 14.6834 16.0976 15.3166 15.7071 15.7071C15.3166 16.0976 14.6834 16.0976 14.2929 15.7071L9.47653 10.8907C8.49572 11.5892 7.29583 12 6 12C2.68629 12 0 9.31371 0 6Z"
                        fill="black"
                        fillOpacity="0.5"
                    />
                </svg>
            </div>
            {searchedUsers
                .filter((item) => item._id !== userProfile._id && item.isFollow)
                .map((item) => {
                    return (
                        <div className="flex items-center justify-between py-2">
                            <div
                                className="flex items-center"
                                onClick={() => {
                                    dispatch(
                                        fetchOtherUserProfileRequest(
                                            item._id,
                                            history
                                        )
                                    );
                                }}
                            >
                                <img
                                    src={getImage(item.attachments)}
                                    alt=""
                                    className="w-[64px] h-[64px] rounded-full mr-3"
                                />
                                <div className="">
                                    <h4 className="text-md font-medium text-black-100 mb-0.5 capitalize whitespace-nowrap">
                                        {item.fullName}
                                    </h4>
                                    <p className="text-black-50">
                                        {"Followed " +
                                            moment(item.dateUpdated).fromNow()}
                                    </p>
                                </div>
                            </div>
                            <div className="flex items-center justify-between">
                                <button
                                    onClick={() =>
                                        history("/page/chat", {
                                            state: {
                                                userId: item._id,
                                            },
                                        })
                                    }
                                    className="p-[7px] mx-3 w-[100px] rounded-lg text-sm font-bold text-white flex items-center justify-center border border-orange-color bg-orange-color capitalize"
                                >
                                    Chatroom
                                </button>
                                <button
                                    onClick={() =>
                                        history("/page/inbox", {
                                            state: {
                                                userId: item._id,
                                            },
                                        })
                                    }
                                    className="p-[7px] w-[100px]	 rounded-lg text-sm font-bold text-white flex items-center justify-center border border-purple-color bg-purple-color capitalize"
                                >
                                    Inmail
                                </button>
                            </div>
                        </div>
                    );
                })}
            {searchedUsers &&
            searchedUsers.filter(
                (item) => item._id !== userProfile._id && item.isFollow
            ).length === 0 ? (
                <Box
                    display="flex"
                    justifyContent="center"
                    className="mt-4"
                    width="100%"
                >
                    <img
                        src={NotFound}
                        alt="icon"
                        className="img-responsive max-h-[200px]"
                    />
                </Box>
            ) : (
                <span />
            )}
        </Grid>
    );
}
